import {DisplayObject, Rectangle, Sprite} from 'pixi.js';
import {AUTOMATION_META, AutomationMeta} from '@gongxigames/framework/core/fragments/Autotest';

export class MovieClip extends Sprite {

    private _frames: Sprite[] = [];
    private _currentFrameID = -1;

    constructor(frames?: Sprite[]) {
        super();

        if (frames) {
            this.setFrames(frames);
        }
    }

    public setFrames(frames: Sprite[]): this {
        this.removeChildren();

        this._currentFrameID = 1;
        this._frames = frames;

        this.addChild(this._frames[this._currentFrameID - 1]);

        return this;
    }

    public gotoAndStop(frame: number): void {
        if (frame < 1) {
            this._currentFrameID = 1;
        } else if (frame > this.totalFrames) {
            this._currentFrameID = this.totalFrames;
        } else {
            this._currentFrameID = frame;
        }

        this.removeChildAt(0);
        this.addChild(this._frames[this._currentFrameID - 1]);
    }

    public get totalFrames(): number {
        return this._frames.length;
    }

    public get currentFrame(): number {
        return this._currentFrameID;
    }

    public set currentFrame(value: number) {
        this._currentFrameID = value;
    }

    // TODO: check
    public getBounds(skipUpdate?: boolean, rect?: Rectangle): Rectangle {
        const newRect = this._frames[this._currentFrameID - 1].getBounds(skipUpdate, rect);

        newRect.x += this.x;
        newRect.y += this.y;

        return newRect;
    }

    public get frames(): DisplayObject[] {
        return this._frames;
    }

    public getCurrentFrameObject(): DisplayObject {
        return this.frames[this._currentFrameID - 1];
    }

    [AUTOMATION_META](): AutomationMeta {
        return {
            type: 'movie_clip',
            frame: this._currentFrameID
        };
    }
}